export default __webpack_public_path__ + "src/assets/Coinbase_Desktop.70c8f0c6ab0963728dcca3f1c21144a3.svg";